import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import SideVertical from "./partials/SideVertical";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Services from "./components/Services";
import About from "./components/About";
import NavTop from "./partials/NavTop";
import NavBot from "./partials/NavBot";
import Footer from "./partials/Footer";
import Home from "./components/Home";
import "./index";

function App() {
  const [preload, setPreload] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(function () {
    const preloadTimer = setTimeout(function () {
      setPreload(false);
    }, 2000);

    return function () {
      clearTimeout(preloadTimer);
    };
  }, []);

  useEffect(function () {
    const routes = ["/", "/about", "/services", "/projects"];

    function handleArrowNavigation(event) {
      const activeElement = document.activeElement;
      const isTyping =
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          activeElement.isContentEditable);

      if (isTyping || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
        return;
      }

      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") {
        return;
      }

      const currentIndex = routes.indexOf(location.pathname);

      if (currentIndex === -1) {
        return;
      }

      event.preventDefault();

      const nextIndex =
        event.key === "ArrowRight"
          ? (currentIndex + 1) % routes.length
          : (currentIndex - 1 + routes.length) % routes.length;

      navigate(routes[nextIndex]);
    }

    window.addEventListener("keydown", handleArrowNavigation);

    return function () {
      window.removeEventListener("keydown", handleArrowNavigation);
    };
  }, [location.pathname, navigate]);

  if (preload) {
    return (
      <>
        <div className="preload">
          <h1>
            <strong>Lee</strong>
          </h1>
          <p>─────</p>
          <Spinner animation="grow" />
        </div>
      </>
    );
  }

  return (
    <>
      <NavTop />
      <div className="page-shell d-flex">
        <SideVertical />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/skills" element={<Skills />}></Route>
          <Route path="/services" element={<Services />}></Route>
          <Route path="/projects" element={<Projects />}></Route>
          <Route path="/contact" element={<Navigate to="/about" replace />}></Route>
        </Routes>
      </div>
      <Footer />
      <NavBot />
    </>
  );
}

export default App;
